
import React from 'react';

const HeroSection: React.FC = () => {
  return (
    <section className="relative h-96 flex items-center justify-center text-white overflow-hidden">
      {/* 背景動画 */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src="https://videos.pexels.com/video-files/6195149/6195149-uhd_2560_1440_25fps.mp4" type="video/mp4" />
        <source src="https://videos.pexels.com/video-files/7578555/7578555-uhd_2560_1440_30fps.mp4" type="video/mp4" />
      </video>
      
      {/* オーバーレイ */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      
      <div className="relative z-10 container mx-auto px-6 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">
          お問い合わせ
        </h1>
        <p className="text-xl md:text-2xl max-w-2xl mx-auto">
          不動産に関するご相談は何でもお気軽にお問い合わせください
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
